/* eslint-disable */
import api, { BASE_URL } from "../api";

const state = {
  loading: false,
  printers: []
};

// getters
const getters = {};

// actions
const actions = {
  initPrinters: context => {
    context.commit("SET_LOADING", true);
    api(context)
      .get(`${BASE_URL}/shop/admin/shop-printer/`)
      .then(response => response.data)
      .then(data => {
        context.commit("DEFAULT_API_RESPONSE", data);
      })
      .catch(error => {
        console.log(error);
        console.log("ERROR");
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  updatePrinter: (context, printer) => {
    context.commit("SET_LOADING", true);
    return api(context)
      .put(`${BASE_URL}/shop/admin/shop-printer/${printer.id}/`, printer)
      .then(response => {
        context.commit("SET_CREATE_ERROR", null);
        return response;
      })
      .catch(error => {
        context.commit("SET_CREATE_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  }
};

// mutations
const mutations = {
  DEFAULT_API_RESPONSE(state, data) {
    state.printers = data;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
